module.exports = __webpack_public_path__ + "img/scuba_1248.37b537f2.png";